/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  ListSettlementsByTenantOptions,
  ListSettlementsByTenantResponses,
} from '../types/ListSettlementsByTenant'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary List settlements by optional filters.
 * {@link /v1/tenants/settlements}
 */
export function listSettlementsByTenant<ThrowOnError extends boolean = true>(
  options: Options<ListSettlementsByTenantOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<ListSettlementsByTenantResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/tenants/settlements',
      security: [{ type: 'http', scheme: 'bearer' }],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListSettlementsByTenantResponses, ThrowOnError>>,
  )
}
